export default {
  mapItems: [],
  mapItem: undefined,
  myLocation: undefined,
};
